export default "__VITE_ASSET__BFEvRfRF__"